/**
 * Maps a metered endpoint back to the feature it serves.
 *
 * `useCreditGate` knows the feature it is guarding and passes it straight to the
 * dialog. The 402 backstop in the response interceptor does not — it sees only
 * an axios error — so the request URL is the one piece of evidence available
 * there. Seven endpoints are metered, so the map is small and closed.
 *
 * A miss is expected and harmless: the dialog falls back to generic copy rather
 * than naming the wrong feature.
 */
const RULES = [
    [/^\/sbcs$/, "solve-sbc-club"],
    [/^\/sbcs\/\d+\/solutions$/, "solve-sbc-club"],
    [/^\/streamlined-sbcs\/\d+\/solutions$/, "solve-sbc-club"],
    [/^\/gallery\/solutions$/, "gallery-solutions-built"],
    [/^\/gallery\/level-plan$/, "gallery-level-plan-built"],
    [/^\/squad-builder(\/|$)/, "build-squad-club"],
    [
        /^\/user-squads\/active\/player-recommendations$/,
        "squad-recommendations-club",
    ],
    [/\/next-evo-steps\/(chains|reveal-chains)(\/|$)/, "evo-chains-club"],
];
/** Strips the origin and query string, leaving a leading-slash path. */
const toPath = (url) => {
    // Indexing is checked in this package, and split() is typed as possibly
    // sparse even though [0] always exists — hence the ?? "".
    const withoutQuery = (url.split("?")[0] ?? "").split("#")[0] ?? "";
    const afterOrigin = withoutQuery.replace(/^https?:\/\/[^/]+/, "");
    return afterOrigin.startsWith("/") ? afterOrigin : `/${afterOrigin}`;
};
export const creditFeatureByPath = (url) => {
    if (!url)
        return undefined;
    const path = toPath(url);
    return RULES.find(([pattern]) => pattern.test(path))?.[1];
};
//# sourceMappingURL=creditFeatureByPath.js.map